// Serves resized, cache-friendly WebP copies of the original CDN assets
// (1-year cache headers, never enlarged beyond the original size).
export function resizedImage(url: string, width: number, quality = 72) {
  return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${width}&output=webp&q=${quality}&we`
}

export function resizedSrcSet(url: string, widths: number[], quality = 72) {
  return widths.map((w) => `${resizedImage(url, w, quality)} ${w}w`).join(', ')
}

export const heroImageWidths = [220, 280, 380, 440]
export const heroImageSizes = '220px'
